<template>
<!-- 作业列表 -->
    <div class="stuInfo">
        <div  class="search-content conditionSearchBox">
            <div class="conditionItem">
                <el-date-picker
                    v-model="dateValue"
                    @change="getTime"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    clearable
                    range-separator="至"
                    start-placeholder="课时开始日期"
                    end-placeholder="课时结束日期">
                </el-date-picker>
            </div>
            <div class="conditionItem">
                <el-select clearable v-model="params.condition.status"  placeholder="作业状态">
                    <el-option
                    v-for="item in workStatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="conditionItem">
                <el-input size="medium" clearable  prefix-icon="el-icon-search" placeholder="课时名称" v-model="params.condition.periodname" ></el-input>
            </div>
            <div class="conditionItem" v-if="!type">
                <el-input size="medium" clearable  prefix-icon="el-icon-search" placeholder="课程名称" v-model="params.condition.classcoursename" ></el-input>
            </div>
            <div class="conditionItem">
                <el-input size="medium" clearable  prefix-icon="el-icon-search" placeholder="学员名称" v-model="params.condition.studentname" ></el-input>
            </div>
            <div class="conditionItem">
                <el-button type="hollowOut" @click="triggerSearch">
                    <i class="el-icon-search mr-5"></i>搜索</el-button>
                <el-button @click="resetSearchCondition">
                    <i class="el-icon-refresh mr-5"></i>重置</el-button>
            </div>
        </div>
        <div class="listBox mt-20">
             <!-- 表格 -->
            <div v-loading="loadingStatus" class="table-content mt-15">
                <el-table class="table-fixed-col" ref="multipleTable" border :data="tableData" style="width: 100%">
                    <el-table-column key="index" type="index" :width="getTableHeaderWidthByOrderCol()"  align="center" label="序号"
                        fixed="left">
                        <template slot-scope="scope">
                            <TableSort :index="scope.$index" :page="params.page" :pagesize="params.pagesize" />
                        </template>
                    </el-table-column>
                    <el-table-column min-width="140" key="classcoursename" show-overflow-tooltip align="center" prop="classcoursename" label="课程名称">
                        <template slot-scope="scope">
                            <span @click="lookDetail(scope.row)" class="pointer color-primary">{{scope.row.classcoursename}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="140" show-overflow-tooltip key="periodname" align="center" prop="periodname" label="课时名称">
                    </el-table-column>
                    <el-table-column min-width="140"  show-overflow-tooltip key="sexname" align="center" prop="sexname" label="课程时间">
                        <template slot-scope="scope">
                            <span>{{scope.row.timnestart}}--{{scope.row.timneend}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="100" key="studentname" show-overflow-tooltip align="center" prop="studentname" label="学员名称">
                    </el-table-column>
                    <el-table-column min-width="140" key="qbname" show-overflow-tooltip align="center" prop="qbname" label="作业名称">
                    </el-table-column>
                    <el-table-column min-width="80" key="statusname" align="center" prop="statusname" label="作业状态">
                    </el-table-column>
                    <el-table-column width="140" key="endtime" align="center" prop="endtime" label="完成时间">
                    </el-table-column>
                    <el-table-column width="80" key="score" align="center" prop="score" label="作业分值">
                    </el-table-column>
                    <el-table-column :width="getTableHeaderWidthByOpButton1()" fixed="right" key="set" align="right" label="操作">
                        <template slot-scope="scope">
                            <div class="color-brand ai-c ">
                                <span  @click="reviewWork(scope.row)" v-if="scope.row.statusname === '待批阅'" class="color-brand pointer">批阅</span>
                                 <span v-else class="color-text-sec ">批阅</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-pagination
                :hide-on-single-page="!total || total < 1"
                class="mt-20 flex ai-c jc-fd"
                @size-change="handePageSizeChange"
                @current-change="curPageChange"
                @prev-click="curPageChange"
                @next-click="curPageChange"
                layout="total, sizes, prev, pager, next"
                :total="total"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                :page-size="20"
                :current-page.sync="params.page"
                background
            ></el-pagination>
        </div>
        <!-- 批阅 -->
        <Correct ref="Correct" />
    </div>
</template>
<script>
import {getCourseExamList} from '@/api/measApi/teachManagement.js'
import {getTableDefaultPageSize} from '@/assets/measAssets/js/tools.js'
import TableSort from '@/components/measComponents/tableSort/tableSort.vue'
import Correct from '../../components/correct.vue'
export default {
    data(){
        return {
            tableData: [],
            loadingStatus: false,
            dateValue: [],
            params: {
                condition: {
                    classcode: '',
                    classcoursecode: '',
                    classcoursename: '',
                    classname: '',
                    infotype: 0,
                    periodcode: '',
                    periodname: '',
                    periodtiemend: '',
                    periodtiemstart: '',
                    studentcode: '',
                    studentname: '',
                    status: ''
                },
                orderbyname: '',
                orderbyorder: '',
                page: 1,
                pagesize: getTableDefaultPageSize()
            },
            workStatus: [
                {label: '未开始', value: 0},
                {label: '考试中', value: 1},
                {label: '待批阅', value: 9},
                {label: '已完成', value: 10},
            ],
            total: 0,
            step: 1
        }
    },
    props: ['type','classCode', 'classCourseCode', 'periodcode'],
    components: {
        TableSort,
        Correct
    },
    created(){
        // this.$nextTick(() => {
        //     this.init()
        // })
    },
    methods: {
        init(isSetParams){
            if (isSetParams) {
                this.params.condition.classcode = this.classCode
                this.params.condition.classcoursecode = this.classCourseCode
                this.params.condition.periodcode = this.periodcode
            }
            this.params.condition.classcode = this.classCode
            this.params.condition.classcoursecode = this.classCourseCode
            // this.params.condition.periodcode = this.periodcode
            if(this.step === 1){
                this.getCourseExamList()
            }
        },
        getCourseExamList(){
            this.loadingStatus = true
            getCourseExamList(this.params).then(res => {
                this.loadingStatus = false
                this.step++
                this.tableData = res.data
                this.total = res.pageinfo.rowcount
                console.log(res,'学情')
            })
        },
        triggerSearch(){
            this.params.page = 1
            this.getCourseExamList()
        },
        resetSearchCondition(){
            this.params.condition.periodtiemstart = ''
            this.params.condition.periodtiemend = ''
            this.params.condition.classcoursename = ''
            this.params.condition.studentname = ''
            this.params.condition.periodname = ''
            this.params.condition.status = ''
            this.dateValue = ''
            this.params.page = 1
            this.getCourseExamList()
        },
        getTime(){
            if(this.dateValue && this.dateValue.length>0){
                this.params.condition.periodtiemstart = this.dateValue[0]
                this.params.condition.periodtiemend = this.dateValue[1]
            }else{
                this.params.condition.periodtiemstart = ''
                this.params.condition.periodtiemend = ''
            }
        },
        reviewWork(row){
             this.$refs.Correct.init(row.code, 0, true)
        },
        lookDetail(row){
            this.$refs.Correct.init(row.code, 0, false)
        },
        handePageSizeChange(e){
            this.params.page = 1
            this.params.pagesize = e
            this.getCourseExamList()
        },
        curPageChange(e){
            console.log(e,'eee')
            this.params.page = 1
            this.params.page = e
            this.getCourseExamList()
        },
    }
}
</script>
<style lang="scss" scoped>
 .conditionSearchBox{
    align-items: flex-start!important;
}
.stuInfo{
    .listBox{
        font-size: 14px;
        .icon-add{
            margin-right: 6px;
        }
    }
}

</style>